import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { tokenNotExpired } from 'angular2-jwt';
import { Routes, Router } from '@angular/router';
import { HttpService } from '../../../shared/services/http/http.service';
import { loginUrl, changePasswordUrl, requestPasswordUrl, resetPasswordUrl, logoutUrl, employeeListUrl } from 'src/app/modules/shared/common/api';

@Injectable()
export class AuthService extends HttpService{
  
  roleID = [1,2,3,4];
  url:any;

   constructor(http: HttpClient, private _router: Router) { 
    super('',http);
  }

  public getToken(): string {
  	return localStorage.getItem('token');
  }


  public isAuthenticated(): boolean {
    const token = this.getToken();
  	return tokenNotExpired(null, token);
  }

  login(data) {
  	return this.http.post(loginUrl, data).map(res => {
      return res['data'];
    }); 
  }

  getAuthToken() {
  	return localStorage.getItem('token');
  }

  getAuthUser() {
  	return JSON.parse(localStorage.getItem('cashUser'));
  }

  setAuthUser(user) {
  	const userDetail = Object.assign({}, user);
  	localStorage.setItem('cashUser', JSON.stringify(userDetail));
  }

  setAuthToken(token) {
    localStorage.setItem('token', token);
  }

  changePassword(data) {
    return this.http.post(changePasswordUrl+'/'+data.id, data).map(res => {
      return res['data'];
    }); 
  }

  requestPassword(data) {
    return this.http.get(requestPasswordUrl+'email='+data).map(res => {
      return res['data'];
    }); 
  }

  resetPassword(data) {
    return this.http.post(resetPasswordUrl, data).map(res => {
      return res['data'];
    }); 
  }

  getEmployee() {
    return this.http.get(employeeListUrl).map(res => {
      return res['data'];
    }); 
  }

  logout(user) {
  	return this.http.post(logoutUrl, user).map(res=>{
      return res['data'];
    });
  }

  prevUrl(url) {
    this.url = url;
  }

}
